module.exports = __webpack_public_path__ + "static/rainbow_inf-181070bfaae67be6f772fa5d42e0afc1.png";